import { Subscription } from "@apuestes/types";
import { initialSubscriptionState } from "../../../../_metronic/helpers";
import { createSlice } from "@reduxjs/toolkit";
import { apuestesAPI } from "../../services/apuestesAPI";

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState: {
        meta: { fetch: false, id: -1 },
        value: initialSubscriptionState
    },
    reducers: {
        setSubscription: (state, action) => {
            state.value = action.payload;
            state.meta.fetch = true;
        },
        clearSubscription: (state) => {
            state.value = initialSubscriptionState;
            state.meta.fetch = false;
            state.meta.id = -1;
        },
        setSubscriptionId: (state, action) => {
            state.meta.id = action.payload;
        }
    },
    extraReducers(builder) {
        builder
        .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'subscriptions') {
              state.value = action.payload as unknown as Subscription;
              state.meta.fetch = true;
              state.meta.id = action.payload.id;
          }
        })
        .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'subscriptions') {
              state.value = action.payload as unknown as Subscription;
              state.meta.fetch = true;
          }
        })
        .addMatcher(apuestesAPI.endpoints.setModel.matchFulfilled, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'subscriptions') {
              state.value = action.payload as unknown as Subscription;
              state.meta.fetch = true;
              state.meta.id = action.payload.id;
          }
        })
        .addMatcher(apuestesAPI.endpoints.getModelById.matchPending, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'subscriptions') {
              state.meta.fetch = false;
          }
        })
        .addMatcher(apuestesAPI.endpoints.getModelById.matchRejected, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'subscriptions') {
              state.meta.fetch = false;
          }
        })
      },
});

export const { setSubscription, clearSubscription, setSubscriptionId } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
